import { voting } from '@mentimeter/http-clients';
import type { UpvoteResults } from '../slide-types/open/components/types';

export const getUpvotes = async (
  voteKey: string,
  questionPublicKey: string,
): Promise<{ data: UpvoteResults }> => {
  const response = await voting().upvotes.get(voteKey, questionPublicKey);
  return { data: { ...response.data, responses: response.data.votes } };
};

export const getMigratedUpvotes = async (
  voteKey: string,
  interactiveContentChoiceId: string,
): Promise<{ data: UpvoteResults }> => {
  const response = await voting().upvotesMigrated.get(
    voteKey,
    interactiveContentChoiceId,
  );
  return {
    data: {
      responses: response.data.responses.map((response) => ({
        id: response.response_id,
        answer: response.answer,
        upvotes: response.upvotes_count,
      })),
    },
  };
};
